import { render, staticRenderFns } from "./PlanSelect.vue?vue&type=template&id=18a4144e&"
import script from "./PlanSelect.vue?vue&type=script&lang=ts&"
export * from "./PlanSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports